import { defineComponent as _defineComponent } from 'vue'
import { customMoment } from "@/main";
import { computed, onUnmounted, reactive, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TickingTime',
  props: {
    currentTime: null
  },
  setup(__props: any) {

const props = __props as { currentTime: string };


const state = reactive({
  interval: -1 as any,
  secondsSinceLoad: 0
})



const timeString = computed(() => {

  return customMoment(props.currentTime)
    .clone()
    .add(state.secondsSinceLoad, "seconds")
    .format("ddd, DD MMM YYYY hh:mm:ss A");
})


function updateTime() {
  state.secondsSinceLoad++;
}
onMounted(() => {
  state.interval = setInterval(() => updateTime(), 1000)
})

onUnmounted(() => {
  clearInterval(state.interval);
})



return { __sfc: true,state, props, timeString, updateTime }
}

})